var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #594fbf;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #827026;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #9c1a87;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #8fd400;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #241f21;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #9ea1d9;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0 18.24 0 9.12 0 0 7.89 4.56 15.79 9.12 7.89 13.68 0 18.24"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "16.1 28.3 16.1 19.18 16.1 10.07 8.2 14.63 .31 19.18 8.2 23.74 16.1 28.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.98 10.12 16.98 19.23 16.98 28.35 24.87 23.79 32.76 19.23 24.87 14.68 16.98 10.12"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "33.32 38.43 33.32 29.32 33.32 20.2 25.42 24.76 17.53 29.32 25.42 33.88 33.32 38.43"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.24 30.29 17.24 39.41 17.24 48.52 25.14 43.97 33.03 39.41 25.14 34.85 17.24 30.29"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "34.21 20.54 34.21 29.66 34.21 38.77 42.11 34.21 50 29.66 42.11 25.1 34.21 20.54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ee59b2a160107a168a500a867a4b7b47.svg";
export { ForwardRef as ReactComponent };